import { API_END_POINTS } from "../../constant/config";
// import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_WIX_CATEGORIES, GET_SINGLE_WIX_CATEGORY} from "../type";
import axios from "axios";
import Filter from "../../utils/Filter";
// Fetch Wix Categories
export const fetchWixCategories = (query) => async (dispatch) => {
    try {
        const search = (query.search===undefined||query.search==="") ? "":query.search;
        const apiEndpoint = API_END_POINTS.FETCH_WIX_CATEGORIES;
        const response = await axios.get(`${apiEndpoint}/?page=${query.pageNumber}&limit=${query.pageSize}&search=${search}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data&&response.data.docs,query);
        console.log(response.data.docs)
        dispatch({
            type: GET_WIX_CATEGORIES,
            payload: response.data.docs,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Get Single Wix Category
export const fetchSingleWixCategory = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCTH_SINGLE_WIX_CATEGORY;
        const response = await axios.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_WIX_CATEGORY,
            payload: response.data.docs,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// update Single wix Category
export const updateWixCategory = (data) => async (dispatch) => {
    try {
        const body ={order :data.order}
        const apiEndpoint = API_END_POINTS.UPDATE_WIX_CATEGORY;
        const response = await axios.put(`${apiEndpoint}/${data.id}`,body);

        return response.data;
    } catch (error) {
        console.log("error", error);
    }
};
